// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
  /* text-align: center; */
  transition: width 0.3s linear;
  /* //overflow-y:scroll; */
  width: 100%;
  padding-block-start: 40px;
  padding-bottom: 0px;
  height: calc(100vh - 50px);
  overflow-x: hidden;
  scrollbar-width: thin;
}

.left-label h5 {
  text-align: center;
  font-size: 20px;
  font-family: Mulish, sans-serif;
  font-weight: 600;
}

.mat-error {
  color: red;
  font-size: 0.75rem;
}

.left-label {
  /* // display: flex; */
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: white;
  width: 100%;
  white-space: nowrap;
  /* Add this line to prevent line breaks */
  overflow: hidden;
  /* Add this line to hide overflowing text */
  text-overflow: ellipsis;
  /* Add this line to show ellipsis for long text */

}

.shift_card {
  padding: 15px;
  /* // background: url(../../../assets/images/bg_login.jpg) no-repeat; */
  width: 800px;
  margin-bottom: 15px;
  background: #f7941e;
  text-align: center;
  color: #fff;
  margin: auto;
  position: relative;
  height: auto;
}

.shift {
  .edit {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  h2 {
    font-size: 1.5rem;
    margin-bottom: 0;
  }

  h3 {
    font-size: 70px;
    font-weight: 100;
    margin: 20px 0;
  }

  .status_icon {
    -webkit-display: flex;
    -moz-display: flex;
    -ms-display: flex;
    -o-display: flex;
    display: flex;
    -moz-justify-content: space-around;
    -ms-justify-content: space-around;
    -o-justify-content: space-around;
    justify-content: space-around;

    .status {
      width: calc(100% /1);

      &:first-child {
        border-right: 1px solid #ccc;
      }

      span {
        color: #292929;
        font-size: 24px;
      }

      p {
        margin-top: 0px;
        font-size: 18px;

      }
    }

  }

}

.volkomn {
  width: 100px;
  margin: auto;
}

.right-label {
  /* // width: calc(135% /2); */
  /* margin: auto !important; */
  margin-left: 55px;
  padding: 0;
}

.shift-content {
  flex-direction: row;
  justify-content: flex-start;
  display: flex;
  width: 100%;
  margin: auto;
  gap: 5px;
  align-items: center;
}

.card_sec {
  border-radius: 0;
  margin-top: 5px;

  table {
    font-size: 0.9em;
    color: #666;
    position: relative;
    overflow-x: auto;
    /* z-index: 1200; */

    td {
      /* // background-color: #1d1e23; */
      font-size: 12px;
      color: black;
    }

    thead {
      th {
        position: sticky;
        border-bottom: 1px solid rgba(224, 224, 224, 1);
        background-color: #ffffff;
        font-size: 18px;
        font-weight: 500;
        color: black;
        font-weight: bold;
        font-family: 'Barlow Condensed', sans-serif;
        line-height: 20px;
        padding: 0.75rem;

        &.mat-header-cell {
          &:first-of-type {
            padding-left: 8px;
          }
        }
      }
    }

    tr {
      height: 35px !important;
      background-color: #3b25e6 !important;

      td {
        font-size: 14px;
        color: black;
        padding: 0.75rem;
        border-bottom: none;

        &.mat-cell,
        &.mat-footer-cell {
          /* // border-bottom: 1px solid #777b85; */
          border-bottom: transparent;

          &:first-of-type {
            padding-left: 8px;
          }
        }

      }
    }
  }

  .mat-paginator-container {
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    justify-content: space-between !important;
    padding: 0 15px !important;

    button {
      padding: 0.5rem 0.75rem;
      line-height: 1.25;

      background-color: #ffffff;
      border: 0;
      border-radius: 0;
      display: inline-block;
      position: relative;

      &.mat-paginator-navigation-previous {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }

      &.mat-paginator-navigation-next {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }

      &:hover {
        color: #3b25e6;
        text-decoration: none;
        cursor: pointer;
        background-color: #2e2e2e;
        border-color: #ddd;
      }

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        svg {
          fill: orange;
        }
      }
    }

  }
}


.example-container {
  height: 65vh;
  overflow: auto;
  scrollbar-width: thin;
  background: #ffffff;


}

.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiCard-root.card_sec.css-bhp9pd-MuiPaper-root-MuiCard-root {
  /* Your CSS rules here */
  border: 2px solid white;
}

.pagecontent {
  display: flex;
  flex-direction: column;
  align-items: center;

}

.odd-row {
  background-color: #f7f7f7;
}

.even-row {
  background-color: #ededed;
}

table td {
  border-bottom: none;
  /* Remove the right border */
}

table tr {
  border-bottom: none;
  /* Remove the bottom border */
}

/* ... previous styles ... */

/* ... previous styles ... */

@media (max-width: 768px) {
  .shift_card {
    width: 70%;
    position: static;
  }

  .shift-content {
    flex-direction: column;
    width: 100%;
  }

  .right-label {
    margin: 20px 0 !important;
    /* margin-left: 55px; */
  }

  .page {
    padding-left: 15px;
    /* Add some padding to the left */
    padding-right: 15px;
    /* Add some padding to the right */
  }
}

@media (max-width: 480px) {
  .shift_card {
    /* width: 100%;
      margin: 10px;
      box-sizing: border-box; */
    display: none;
  }

  /* .shift-content {
      flex-direction: column;
      align-items: center;
    } */

  .right-label {
    width: 100%;
    margin: 20px 0 !important;
  }

  .page {
    padding-left: 10px;
    /* Reduce the left padding for smaller screens */
    padding-right: 10px;
    /* Reduce the right padding for smaller screens */
  }
}

/* styles.css */
.machinedialog.mat-mdc-form-field-infix {
  flex: auto;
  min-width: 0;
  width: 180px;
  position: relative;
  background-color: grey;
  box-sizing: border-box;
}

.machinedialog.mat-form-field-appearance-outline .mat-form-field-outline {
  background-color: #666 !important;
  border-radius: 5px;
  border: unset;
}

.machinedialog .mat-form-field-appearance-outline .mat-form-field-outline {
  background-color: #202739 !important;
  border-radius: 5px;
  border: unset;
}

.form_sec_fields .form_field {
  width: 32%;
  margin-right: 10px;
  margin-bottom: 10px;
}

.form_sec_fields .form_field.time_field_bg,
.time_field_bg {
  background: #ffffff;
  padding: 20px;
  border-radius: 20px;


}

.form_sec_fields {
  -webkit-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  -o-display: flex;
  display: flex;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
  align-items: flex-end;
  margin-left: 15px;

  .form_field {
    width: 31%;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .ngb-tp-input {
    padding: 0;
    font-size: 28px;

  }

}

.shift_form .form_field {
  margin-bottom: 20px;
  margin-right: 10px;
}

.css-e784if-MuiTypography-root {
  color: black;
}

.close_modal {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #a3a0a0;

  mat-icon {
    font-size: 20px;
    color: #0e121b;
    background-color: white;
    align-items: center;

  }
}

.error-message {
  color: red;
  font-size: 0.75rem;
}

.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  padding-right: 32px;
  color: white;
}

@media screen and (max-width:600px) {
  .form_field {
    width: 100%;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .form_sec_fields {
    flex-direction: column;
  }

  .form_sec_fields .form_field.time_field_bg,
  .time_field_bg {
    width: 100%;


  }

  .form_sec_fields .form_field {
    width: 100%;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

/* .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {
  color: white !important;
 } */
.error-outline .MuiOutlinedInput-notchedOutline,
.error-outline .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,
.error-outline .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: red !important;
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/Pages/Userregistration/userreg.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,2CAA2C;EAC3C,uBAAuB;EACvB,iDAAiD;;AAEnD;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IAEb,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,6BAA6B;;IAE7B;MACE,oBAAoB;;MAEpB;QACE,4BAA4B;MAC9B;;MAEA;QACE,cAAc;QACd,eAAe;MACjB;;MAEA;QACE,eAAe;QACf,eAAe;;MAEjB;IACF;;EAEF;;AAEF;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;;EAEf;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;;IAEnB;MACE,kCAAkC;MAClC,eAAe;MACf,YAAY;IACd;;IAEA;MACE;QACE,gBAAgB;QAChB,+CAA+C;QAC/C,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,2CAA2C;QAC3C,iBAAiB;QACjB,gBAAgB;;QAEhB;UACE;YACE,iBAAiB;UACnB;QACF;MACF;IACF;;IAEA;MACE,uBAAuB;MACvB,oCAAoC;;MAEpC;QACE,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;;QAEnB;;UAEE,yCAAyC;UACzC,0BAA0B;;UAE1B;YACE,iBAAiB;UACnB;QACF;;MAEF;IACF;EACF;;EAEA;IAEE,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,yCAAyC;IACzC,0BAA0B;;IAE1B;MACE,uBAAuB;MACvB,iBAAiB;;MAEjB,yBAAyB;MACzB,SAAS;MACT,gBAAgB;MAChB,qBAAqB;MACrB,kBAAkB;;MAElB;QACE,2BAA2B;QAC3B,8BAA8B;MAChC;;MAEA;QACE,4BAA4B;QAC5B,+BAA+B;MACjC;;MAEA;QACE,cAAc;QACd,qBAAqB;QACrB,eAAe;QACf,yBAAyB;QACzB,kBAAkB;MACpB;;MAEA;QACE,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;;QAEhC;UACE,YAAY;QACd;MACF;IACF;;EAEF;AACF;;;AAGA;EACE,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,mBAAmB;;;AAGrB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;AAErB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,4BAA4B;;AAE5B,4BAA4B;;AAE5B;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;IACnB,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE;;+BAE2B;IAC3B,aAAa;EACf;;EAEA;;;OAGK;;EAEL;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,gDAAgD;IAChD,mBAAmB;IACnB,iDAAiD;EACnD;AACF;;AAEA,eAAe;AACf;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;;;AAGrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EAIb,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;;EAEjB;IACE,UAAU;IACV,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,eAAe;;EAEjB;;AAEF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;;EAEd;IACE,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,mBAAmB;;EAErB;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;;;EAGb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;;IAEI;AACJ;;;EAGE,4BAA4B;EAC5B,uBAAuB;AACzB","sourcesContent":[".page {\n  /* text-align: center; */\n  transition: width 0.3s linear;\n  /* //overflow-y:scroll; */\n  width: 100%;\n  padding-block-start: 40px;\n  padding-bottom: 0px;\n  height: calc(100vh - 50px);\n  overflow-x: hidden;\n  scrollbar-width: thin;\n}\n\n.left-label h5 {\n  text-align: center;\n  font-size: 20px;\n  font-family: Mulish, sans-serif;\n  font-weight: 600;\n}\n\n.mat-error {\n  color: red;\n  font-size: 0.75rem;\n}\n\n.left-label {\n  /* // display: flex; */\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n  width: 100%;\n  white-space: nowrap;\n  /* Add this line to prevent line breaks */\n  overflow: hidden;\n  /* Add this line to hide overflowing text */\n  text-overflow: ellipsis;\n  /* Add this line to show ellipsis for long text */\n\n}\n\n.shift_card {\n  padding: 15px;\n  /* // background: url(../../../assets/images/bg_login.jpg) no-repeat; */\n  width: 800px;\n  margin-bottom: 15px;\n  background: #f7941e;\n  text-align: center;\n  color: #fff;\n  margin: auto;\n  position: relative;\n  height: auto;\n}\n\n.shift {\n  .edit {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    cursor: pointer;\n  }\n\n  h2 {\n    font-size: 1.5rem;\n    margin-bottom: 0;\n  }\n\n  h3 {\n    font-size: 70px;\n    font-weight: 100;\n    margin: 20px 0;\n  }\n\n  .status_icon {\n    -webkit-display: flex;\n    -moz-display: flex;\n    -ms-display: flex;\n    -o-display: flex;\n    display: flex;\n    -webkit-justify-content: space-around;\n    -moz-justify-content: space-around;\n    -ms-justify-content: space-around;\n    -o-justify-content: space-around;\n    justify-content: space-around;\n\n    .status {\n      width: calc(100% /1);\n\n      &:first-child {\n        border-right: 1px solid #ccc;\n      }\n\n      span {\n        color: #292929;\n        font-size: 24px;\n      }\n\n      p {\n        margin-top: 0px;\n        font-size: 18px;\n\n      }\n    }\n\n  }\n\n}\n\n.volkomn {\n  width: 100px;\n  margin: auto;\n}\n\n.right-label {\n  /* // width: calc(135% /2); */\n  /* margin: auto !important; */\n  margin-left: 55px;\n  padding: 0;\n}\n\n.shift-content {\n  flex-direction: row;\n  justify-content: flex-start;\n  display: flex;\n  width: 100%;\n  margin: auto;\n  gap: 5px;\n  align-items: center;\n}\n\n.card_sec {\n  border-radius: 0;\n  margin-top: 5px;\n\n  table {\n    font-size: 0.9em;\n    color: #666;\n    position: relative;\n    overflow-x: auto;\n    /* z-index: 1200; */\n\n    td {\n      /* // background-color: #1d1e23; */\n      font-size: 12px;\n      color: black;\n    }\n\n    thead {\n      th {\n        position: sticky;\n        border-bottom: 1px solid rgba(224, 224, 224, 1);\n        background-color: #ffffff;\n        font-size: 18px;\n        font-weight: 500;\n        color: black;\n        font-weight: bold;\n        font-family: 'Barlow Condensed', sans-serif;\n        line-height: 20px;\n        padding: 0.75rem;\n\n        &.mat-header-cell {\n          &:first-of-type {\n            padding-left: 8px;\n          }\n        }\n      }\n    }\n\n    tr {\n      height: 35px !important;\n      background-color: #3b25e6 !important;\n\n      td {\n        font-size: 14px;\n        color: black;\n        padding: 0.75rem;\n        border-bottom: none;\n\n        &.mat-cell,\n        &.mat-footer-cell {\n          /* // border-bottom: 1px solid #777b85; */\n          border-bottom: transparent;\n\n          &:first-of-type {\n            padding-left: 8px;\n          }\n        }\n\n      }\n    }\n  }\n\n  .mat-paginator-container {\n    -webkit-justify-content: space-between;\n    -moz-justify-content: space-between;\n    -ms-justify-content: space-between;\n    -o-justify-content: space-between;\n    justify-content: space-between !important;\n    padding: 0 15px !important;\n\n    button {\n      padding: 0.5rem 0.75rem;\n      line-height: 1.25;\n\n      background-color: #ffffff;\n      border: 0;\n      border-radius: 0;\n      display: inline-block;\n      position: relative;\n\n      &.mat-paginator-navigation-previous {\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 5px;\n      }\n\n      &.mat-paginator-navigation-next {\n        border-top-right-radius: 5px;\n        border-bottom-right-radius: 5px;\n      }\n\n      &:hover {\n        color: #3b25e6;\n        text-decoration: none;\n        cursor: pointer;\n        background-color: #2e2e2e;\n        border-color: #ddd;\n      }\n\n      span {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n\n        svg {\n          fill: orange;\n        }\n      }\n    }\n\n  }\n}\n\n\n.example-container {\n  height: 65vh;\n  overflow: auto;\n  scrollbar-width: thin;\n  background: #ffffff;\n\n\n}\n\n.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiCard-root.card_sec.css-bhp9pd-MuiPaper-root-MuiCard-root {\n  /* Your CSS rules here */\n  border: 2px solid white;\n}\n\n.pagecontent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n}\n\n.odd-row {\n  background-color: #f7f7f7;\n}\n\n.even-row {\n  background-color: #ededed;\n}\n\ntable td {\n  border-bottom: none;\n  /* Remove the right border */\n}\n\ntable tr {\n  border-bottom: none;\n  /* Remove the bottom border */\n}\n\n/* ... previous styles ... */\n\n/* ... previous styles ... */\n\n@media (max-width: 768px) {\n  .shift_card {\n    width: 70%;\n    position: static;\n  }\n\n  .shift-content {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .right-label {\n    margin: 20px 0 !important;\n    /* margin-left: 55px; */\n  }\n\n  .page {\n    padding-left: 15px;\n    /* Add some padding to the left */\n    padding-right: 15px;\n    /* Add some padding to the right */\n  }\n}\n\n@media (max-width: 480px) {\n  .shift_card {\n    /* width: 100%;\n      margin: 10px;\n      box-sizing: border-box; */\n    display: none;\n  }\n\n  /* .shift-content {\n      flex-direction: column;\n      align-items: center;\n    } */\n\n  .right-label {\n    width: 100%;\n    margin: 20px 0 !important;\n  }\n\n  .page {\n    padding-left: 10px;\n    /* Reduce the left padding for smaller screens */\n    padding-right: 10px;\n    /* Reduce the right padding for smaller screens */\n  }\n}\n\n/* styles.css */\n.machinedialog.mat-mdc-form-field-infix {\n  flex: auto;\n  min-width: 0;\n  width: 180px;\n  position: relative;\n  background-color: grey;\n  box-sizing: border-box;\n}\n\n.machinedialog.mat-form-field-appearance-outline .mat-form-field-outline {\n  background-color: #666 !important;\n  border-radius: 5px;\n  border: unset;\n}\n\n.machinedialog .mat-form-field-appearance-outline .mat-form-field-outline {\n  background-color: #202739 !important;\n  border-radius: 5px;\n  border: unset;\n}\n\n.form_sec_fields .form_field {\n  width: 32%;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.form_sec_fields .form_field.time_field_bg,\n.time_field_bg {\n  background: #ffffff;\n  padding: 20px;\n  border-radius: 20px;\n\n\n}\n\n.form_sec_fields {\n  -webkit-display: flex;\n  -moz-display: flex;\n  -ms-display: flex;\n  -o-display: flex;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -moz-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  -o-flex-wrap: wrap;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  margin-left: 15px;\n\n  .form_field {\n    width: 31%;\n    margin-right: 10px;\n    margin-bottom: 10px;\n  }\n\n  .ngb-tp-input {\n    padding: 0;\n    font-size: 28px;\n\n  }\n\n}\n\n.shift_form .form_field {\n  margin-bottom: 20px;\n  margin-right: 10px;\n}\n\n.css-e784if-MuiTypography-root {\n  color: black;\n}\n\n.close_modal {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  color: #a3a0a0;\n\n  mat-icon {\n    font-size: 20px;\n    color: #0e121b;\n    background-color: white;\n    align-items: center;\n\n  }\n}\n\n.error-message {\n  color: red;\n  font-size: 0.75rem;\n}\n\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  padding-right: 32px;\n  color: white;\n}\n\n@media screen and (max-width:600px) {\n  .form_field {\n    width: 100%;\n    margin-right: 10px;\n    margin-bottom: 10px;\n  }\n\n  .form_sec_fields {\n    flex-direction: column;\n  }\n\n  .form_sec_fields .form_field.time_field_bg,\n  .time_field_bg {\n    width: 100%;\n\n\n  }\n\n  .form_sec_fields .form_field {\n    width: 100%;\n    margin-right: 10px;\n    margin-bottom: 10px;\n  }\n}\n\n/* .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {\n  color: white !important;\n } */\n.error-outline .MuiOutlinedInput-notchedOutline,\n.error-outline .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,\n.error-outline .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: red !important;\n  color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
